export default "__VITE_ASSET__C4f6oQ4y__"